<template>
<div class="col-lg-6 wow fadeInUp" data-wow-duration="1500ms">
    <div class="title-section">
        <div class="subtitle-hr d-flex align-items-center">
            <h6 class="subtitle theme-color text-uppercase position-relative">FAQ's</h6>
            <hr>
        </div>
        <h2 class="title text-md-left text-center f-20">Some Questions Our Clients Ask About The Assessments:</h2>
    </div>
    <div class="mt-4">
        <div id="accordion" class="wow fadeInUp" data-wow-duration="1500ms">
            <div class="accordion-card bg-white mb-4 shadow rounded active">
                <div class="card-header border-0 p-0" id="heading1">
                    <h5 class="mb-0">
                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color" data-toggle="collapse" data-target="#collapse1" aria-expanded="false" aria-controls="collapse1"><span class="font-weight-medium">
                                Is it time consuming to complete an assessment?
                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                    </h5>
                </div>
                <div id="collapse1" class="collapse show" aria-labelledby="heading1" data-parent="#accordion">
                    <div class="pt-2">
                        <p class="m-0">
                            Our assessments can be completed in 30 – 50 minutes. You don’t have to complete the assessments on the go; you can start it, save it, and continue later. Completing the assessments would be a great time spent growing your business.
                        </p>
                    </div>
                </div>
            </div>
            <div class="accordion-card bg-white mb-4 shadow rounded">
                <div class="card-header border-0 p-0" id="heading2">
                    <h5 class="mb-0">
                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapse2" aria-expanded="false" aria-controls="collapse2"><span class="font-weight-medium">
                                What are the types of pricing packages we offer?
                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                    </h5>
                </div>
                <div id="collapse2" class="collapse" aria-labelledby="heading2" data-parent="#accordion">
                    <div class="pt-2">
                        <p class="m-0">
                            For the next 60 days, we offer you the ability to complete our assessments and get your score for free. You will have the option to pay for one of three reports:
                            <ul>
                                <li>Graphical Score Report</li>
                                <li>Anchor Readiness Report – Summary</li>
                                <li>Anchor Readiness Report – Detail</li>
                            </ul>
                        </p>
                    </div>
                </div>
            </div>
            <div class="accordion-card bg-white mb-4 shadow rounded">
                <div class="card-header border-0 p-0" id="heading3">
                    <h5 class="mb-0">
                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapse3" aria-expanded="false" aria-controls="collapse3"><span class="font-weight-medium">How detailed is the reporting base on results?
                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                    </h5>
                </div>
                <div id="collapse3" class="collapse" aria-labelledby="heading3" data-parent="#accordion">
                    <div class="pt-2">
                        <p class="m-0">
                            The reports are insightful. We break assessments down into key strategic areas providing weighting based on best practices in the respective areas. Our summary level and detailed reports provide insights and recommendations to strengthen your business operation and move you closer to achieving your goals.
                        </p>

                    </div>
                </div>
            </div>
             <div class="accordion-card bg-white mb-4 shadow rounded">
                <div class="card-header border-0 p-0" id="heading4">
                    <h5 class="mb-0">
                        <button class="link-btn p-0 text-left border-0 bg-white w-100 d-flex justify-content-between align-items-center theme-color collapsed" data-toggle="collapse" data-target="#collapse4" aria-expanded="false" aria-controls="collapse4"><span class="font-weight-medium">What if I need more help?
                            </span><span><i class="mdi mdi-chevron-down d-flex f-30"></i></span></button>
                    </h5>
                </div>
                <div id="collapse4" class="collapse" aria-labelledby="heading4" data-parent="#accordion">
                    <div class="pt-2">
                        <p class="m-0">
                          The Anchor team of experts can provide one-to-one consulting support to help you and your team address the gaps identified from the assessment.  We can also supplement your execution team as you work to implement the new recommendations.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: "faqs",
    methods: {

    },
    mounted() {

        //alert("Product type: "+this.product);
    }
}
</script>
